<template>
  <basic-container>
    <div class="search_group">
      <el-date-picker v-model="searchTime" size="small" value-format="yyyy-MM-dd" type="daterange" start-placeholder="创建开始时间" end-placeholder="创建结束时间"></el-date-picker>
      <el-input :maxlength="100" v-model="orderNo" size="small" placeholder="订单编号"></el-input>
      <el-input :maxlength="50" v-model="enterpriseName" size="small" placeholder="企业名称"></el-input>
      <el-input :maxlength="80" v-model="deptId" size="small" placeholder="企业ID"></el-input>
      <el-input :maxlength="80" v-model="payOrderNo" size="small" placeholder="商户单号"></el-input>
      <el-input :maxlength="80" v-model="mobile" size="small" placeholder="用户账号"></el-input>
      <el-date-picker v-model="orderCreateDate" type="date" size="small" value-format="yyyy-MM-dd" placeholder="下单时间"></el-date-picker>
      <el-date-picker v-model="payTime" type="date" size="small" value-format="yyyy-MM-dd" placeholder="支付时间"></el-date-picker>
      <el-date-picker v-model="refundTime" type="date" size="small" value-format="yyyy-MM-dd" placeholder="退款时间"></el-date-picker>
      <el-select @change="searchAct" v-model="appId" size="small" filterable clearable placeholder="来源渠道">
        <el-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select @change="selectData" v-model="payType" size="small" clearable placeholder="支付方式" multiple collapse-tags>
        <el-option label="微信" :value="1"></el-option>
        <el-option label="支付宝" :value="2"></el-option>
        <el-option label="IOS内购" :value="5"></el-option>
      </el-select>
      <el-select @change="selectData" v-model="orderStatus" size="small" clearable placeholder="订单状态" multiple collapse-tags>
        <el-option label="未支付" :value="1"></el-option>
        <el-option label="已支付" :value="2"></el-option>
        <el-option label="已退款" :value="3"></el-option>
      </el-select>
      <el-select @change="selectData" v-model="refundStatus" size="small" clearable placeholder="退款状态" multiple collapse-tags>
        <el-option label="未申请" :value="0"></el-option>
        <el-option label="待处理" :value="1"></el-option>
        <el-option label="已退款" :value="2"></el-option>
        <el-option label="拒绝退款" :value="3"></el-option>
      </el-select>
      <el-select @change="selectData" v-model="fixStatus" size="small" clearable placeholder="补单状态" multiple collapse-tags>
        <el-option label="未申请" :value="0"></el-option>
        <el-option label="待处理" :value="1"></el-option>
        <el-option label="已补单" :value="2"></el-option>
        <el-option label="已拒绝" :value="3"></el-option>
      </el-select>
      <el-select @change="selectData" v-model="productType" size="small" filterable clearable placeholder="订单商品类型" multiple collapse-tags>
        <el-option v-for="item in productTypeList" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
      </el-select>
      <!-- <el-select @change="searchAct" v-model="buyWay" size="small" clearable placeholder="购买来源">
        <el-option label="Android手机" :value="1"></el-option>
        <el-option label="Windows电脑" :value="2"></el-option>
      </el-select> -->
      <el-select @change="selectData" v-model="categoryType" size="small" clearable placeholder="类别" multiple collapse-tags>
        <el-option label="非续费" :value="0"></el-option>
        <el-option label="续费" :value="1"></el-option>
      </el-select>
      <el-select @change="selectData" v-model="invoiceStatus" size="small" clearable placeholder="开票状态" multiple collapse-tags>
         <el-option label="未申请" :value="0"></el-option>
        <el-option label="待开票" :value="1"></el-option>
        <el-option label="已开票" :value="2"></el-option>
        <el-option label="开票失败" :value="3"></el-option>
      </el-select>
       <el-select @change="selectData" v-model="orderType" size="small" clearable placeholder="业务状态" multiple collapse-tags>
         <el-option label="前端购买" :value="1"></el-option>
        <el-option label="买dongle赠送" :value="2"></el-option>
      </el-select>
      <el-button @click="searchAct" icon="el-icon-search" size="small" type="primary">搜索</el-button>
      <el-button @click="exportList" v-auth="'memberOrder_export'" icon="el-icon-download" size="small" type="primary">导出</el-button>
    </div>
    <div class="table" v-loading="listLoading" element-loading-text="加载中">
        <avue-crud :option="avueOption"
          :table-loading="loading"
          :data="tableData"
          ref="crud"
          :page.sync="page"
          @expand-change="expandChanges"
          @on-load="onLoad">
          <template slot-scope="scope" slot="isRenew">
            {{ scope.row.isRenew==0 ? '非续费': scope.row.isRenew ==1 ? '续费' : '' }}
          </template>
          <template slot-scope="scope" slot="orderType">
            {{ scope.row.orderType==1 ? '前端购买': scope.row.orderType ==2 ? '买dongle赠送' : '' }}
          </template>
          <template slot-scope="scope" slot="payType">{{scope.row.payType | payType}}</template>
          <template slot-scope="scope" slot="payStatus">
            {{scope.row.payStatus==1?'未支付':scope.row.payStatus==2?'已支付':scope.row.payStatus==3?'已退款':''}}
          </template>
          <template slot-scope="scope" slot="refundReviewStatus">{{scope.row.refundReviewStatus | refundStatus}}</template>
          <template slot-scope="scope" slot="supplementReviewStatus">{{scope.row.supplementReviewStatus | fixStatus}}</template>
          <template slot-scope="scope" slot="invoiceReviewStatus">{{scope.row.invoiceReviewStatus | invoiceStatus}}</template>
          <template slot-scope="scope" slot="menu">
            <el-button @click="openFreeDetail(scope.row.freeRecordList[0])" v-if="scope.row.freeRecordList.length !== 0 "  icon="el-icon-info" size="mini" type="text">赠品详情</el-button>
            <el-button @click="openRefund(scope.row)" v-if="((scope.row.refundReviewStatus==0||scope.row.refundReviewStatus==3)&&scope.row.payStatus==2) " v-auth="'memberOrder_refund'" icon="el-icon-info" size="mini" type="text">申请退款</el-button>
            <el-button @click="openFix(scope.row)" v-if="(scope.row.refundReviewStatus==0||scope.row.refundReviewStatus==3)&&(scope.row.supplementReviewStatus==0||scope.row.supplementReviewStatus==3)&&scope.row.payStatus==1" v-auth="'memberOrder_fix'" icon="el-icon-info" size="mini" type="text">申请补单</el-button>
          </template>
        </avue-crud>
    </div>
    <el-dialog title="补单申请" :visible.sync="showFix" append-to-body width="40%">
      <el-form ref="form" :model="checkItem" label-width="110px">
        <el-form-item label="订单编号">{{checkItem.id}}</el-form-item>
        <el-form-item label="用户账户">{{checkItem.mobile}}</el-form-item>
        <el-form-item label="订单商品名称">{{checkItem.productName}}</el-form-item>
        <el-form-item label="支付方式">{{checkItem.payType | payType}}</el-form-item>
        <el-form-item class="form-upload-img" label="凭据">
          <img v-if="voucher" :src="voucher" />
          <div class="upload-box el-button el-button--primary el-button--small">
            <i class="el-icon-upload"></i>
            <span>点击上传文件</span>
            <input @change="handleUpload" type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" name="file" />
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="fixRemark" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitFix" v-auth="'memberOrder_fix'" size="small" type="primary" icon="el-icon-circle-check">确认申请补单</el-button>
        <el-button @click="showFix=false" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="退款申请" :visible.sync="showRefund" append-to-body width="40%">
      <el-form ref="form" :model="checkItem" label-width="110px">
        <el-form-item label="订单编号">{{checkItem.id}}</el-form-item>
        <el-form-item label="用户账户">{{checkItem.mobile}}</el-form-item>
        <el-form-item label="支付方式">{{checkItem.payType | payType}}</el-form-item>
        <el-form-item label="支付金额">{{checkItem.payAmount}} </el-form-item>
        <el-form-item label="退款方式">
          <el-radio v-model="refundType" v-show="checkItem.orderType===1" :label="1">退款不退货</el-radio>
          <el-radio v-model="refundType" v-show="checkItem.orderType===1" :label="2">退款且退货</el-radio>
          <el-radio v-model="refundType" v-show="checkItem.orderType!==1" :label="2" >退货</el-radio>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input-number v-model="refundMoney" :disabled="checkItem.orderType===2" size="small" :precision="2" :step="0.1" :min="0" :max="9999999999"></el-input-number> 元
        </el-form-item>
        <el-form-item label="退款理由">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="refundMark" placeholder="请输入文字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitRefund" v-auth="'memberOrder_refund'" size="small" type="primary" icon="el-icon-circle-check">确认申请退款</el-button>
        <el-button @click="showRefund=false" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>

    <!-- 订单赠品展示详情 -->
      <el-dialog title="赠品详情" :visible.sync="showFreeDetail" append-to-body width="40%">
      <el-form ref="form" :model="freeDetail" label-width="130px">
        <el-form-item label="附赠商品会员类型">{{ freeDetail.freeType == 1 ? '企业会员' : '' }}</el-form-item>
        <el-form-item label="附赠商品编号">{{freeDetail.productCode}}}}</el-form-item>
        <el-form-item label="附赠商品名称">{{freeDetail.productName}}</el-form-item>
        <el-form-item label="合伙人账号">{{freeDetail.distributorAccount}}</el-form-item>
        <el-form-item label="绑定邀请码">{{freeDetail.distributorCode}}</el-form-item>
      </el-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import { orderList, appChannelList, listProductType, applyForSupplement, applyForRefund, putFile } from '@/api/member'
import { exportOrder } from '@/services'
import { debounce, deepCopy } from '@/util/common'
import { mapGetters } from 'vuex'
import pagination from '@/util/mixins/pagination'
export default {
  mixins: [pagination],
  data () {
    return {
      tableData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      avueOption: {
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        height: 'auto',
        calcHeight: 200,
        tip: false,
        searchShow: true,
        searchMenuSpan: 2,
        border: true,
        index: false,
        selection: true,
        column: [{
          label: '订单编号',
          prop: 'id',
          width: 200,
          align: 'left',
        }, {
          label: '商户单号',
          prop: 'payOrderNo',
          width: 200,
          align: 'left',
        }, {
          label: '类别',
          prop: 'isRenew',
          width: 180,
          slot: true,
          align: 'center',
        }, {
          label: '购买来源',
          prop: 'orderSource',
          width: 180,
          align: 'center',
        }, {
          label: '企业名称',
          prop: 'enterpriseName',
          width: 180,
          align: 'center',
        }, {
          label: '企业ID',
          prop: 'deptId',
          width: 200,
          align: 'center'
        }, {
          label: '订单商品类型',
          prop: 'productTypeName',
          width: 200,
          align: 'center'
        }, {
          label: '订单商品名称',
          prop: 'productName',
          width: 200,
          align: 'center'
        }, {
          label: '用户账号',
          prop: 'mobile',
          width: 200,
          align: 'center'
        }, {
          label: '来源渠道',
          prop: 'channelSource',
          width: 200,
          align: 'center'
        },  {
          label: '业务类型',
          prop: 'orderType',
          width: 200,
          slot: true,
          align: 'center'
        }, {
          label: '下单时间',
          prop: 'createTime',
          width: 200,
          align: 'center'
        }, {
          label: '商品原价（元）',
          prop: 'originalAmount',
          width: 200,
          align: 'center'
        }, {
          label: '商品折扣价',
          prop: 'discountPrice',
          width: 200,
          align: 'center'
        }, {
          label: '订单数量',
          prop: 'productCount',
          width: 200,
          align: 'center'
        }, {
          label: '支付时间',
          prop: 'payTime',
          width: 200,
          align: 'center'
        }, {
          label: '支付方式',
          prop: 'payType',
          slot: true,
          width: 200,
          align: 'center',
        }, {
          label: '订单状态',
          prop: 'payStatus',
          slot: true,
          width: 200,
          align: 'center'
        }, {
          label: '退款时间',
          prop: 'refundTime',
          width: 200,
          align: 'center'
        }, {
          label: '退款状态',
          prop: 'refundReviewStatus',
          slot: true,
          width: 200,
          align: 'center'
        }, {
          label: '补单状态',
          prop: 'supplementReviewStatus',
          slot: true,
          width: 200,
          align: 'center'
        }, {
          label: '开票状态',
          prop: 'invoiceReviewStatus',
          slot: true,
          width: 200,
          align: 'center'
        }, {
          label: '备注',
          prop: 'remarks',
          width: 200,
          align: 'center',
          hide:true
        },{
          label: '会员生效开始日期',
          prop: 'licenseStartDate',
          width: 200,
          align: 'center',
        },{
          label: '会员生效结束日期',
          prop: 'licenseEndDate',
          width: 200,
          align: 'center',
        }]
      },
      productTypeList: [], // 商品列表
      channelList: [], // 渠道列表
      orderNo: '', // 订单编号
      enterpriseName: '', // 企业名称
      deptId: '', // 企业ID
      mobile:'',//用户账号
      payOrderNo: '', // 商户单号
      searchTime: '', // 时间
      orderCreateDate: '', // 下单时间
      payTime: '', // 支付时间
      refundTime: '', // 退款时间
      appId: '', // 来源渠道
      payType: [], // 支付方式
      orderStatus: [], // 订单状态
      refundStatus: [], // 退款状态
      fixStatus: [], // 补单状态
      productType: [], // 订单商品类型
      buyWay: '', // 购买来源
      categoryType: [], // 类别
      invoiceStatus: [], // 开票状态
      orderType:[], //业务状态
      checkItem: {}, // 查看项
      refundType: '', // 退款方式
      refundMoney: '', // 退款金额
      refundMark: '', // 退款备注
      showRefund: false, // 退款弹窗
      showFreeDetail : false, //赠品详情弹窗
      voucher: '', // 凭证图片
      fixRemark: '', // 补单备注
      showFix: false, // 补单弹窗
      freeDetail: {}, // 订单赠品展示更多
      payTypePost: ''
    }
  },
  computed: {
    ...mapGetters(['searchOrder']),
    ...mapGetters('app', ['tableHeight']),
    height() {
      return this.tableHeight > 0 ? this.tableHeight - 40 : 400;
    }
  },
  created () {
    console.log(this.$route.query.orderId)
    this.orderNo = this.$route.query.orderId //从合伙人收益记录跳转过来的数据作为key查询
    // this.orderNo = '1333971730328240130' //调试数据
    this.getList()
  },
  mounted () {
    if (this.searchOrder) {
      this.orderNo = this.searchOrder
      this.$store.dispatch('app/setOrder', '')
    }
    listProductType().then(res => {
      if (res.data.code === 200) {
        this.productTypeList = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
    appChannelList().then(res => {
      if (res.data.code === 200) {
        this.channelList = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
    this.getList()
  },
  methods: {
    selectData (value) {
      console.log(value)
      // this.payTypePost = this.payType.join(',')
      this.pageNo = 1
      this.getList()
    },
    // 重新加载数据
    onLoad() {
      this.getList()
    },
    // 打开补单申请
    openFix (item) {
      this.fixRemark = ''
      this.voucher = ''
      this.checkItem = deepCopy(item)
      this.showFix = true
    },
    // 打开退款申请
    openRefund (item) {
      console.log(this.orderType !== 1)
      this.orderType !== 1 ? this.refundType = 2 : this.refundType = 1
      this.refundMoney = ''
      this.refundMark = ''
      this.checkItem = deepCopy(item)
      this.showRefund = true
    },
    openFreeDetail (item) {
      this.freeDetail = deepCopy(item)
      this.showFreeDetail = true
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        startDate: this.searchTime ? this.searchTime[0] : '',
        endDate: this.searchTime ? this.searchTime[1] : '',
        orderId: this.orderNo,
        enterpriseName: this.enterpriseName,
        deptId: this.deptId,
        payOrderNo: this.payOrderNo,
        mobile: this.mobile,
        orderCreateDate: this.orderCreateDate,
        payTime: this.payTime,
        refundTime: this.refundTime,
        appId: this.appId,
        payType: this.payType.join(','),
        payStatus: this.orderStatus.join(','),
        refundReviewStatus: this.refundStatus.join(','),
        supplementReviewStatus: this.fixStatus.join(','),
        productType: this.productType.join(','),
        // 购买来源
        isRenew: this.categoryType.join(','),
        invoiceReviewStatus: this.invoiceStatus.join(','),
        orderType: this.orderType.join(','),
        current: this.page.currentPage,
        size: this.page.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        const { data, code, msg } = res.data;
        if (code === 200) {
          this.tableData = data.records
          this.page.total = data.total
          this.totalEl = data.total
        } else {
          this.$message.error(msg)
        }
      }
      orderList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 上传凭证
    handleUpload (e) {
      let formData = new FormData()
      formData.append('file', e.target.files[0])
      e.target.value = ''
      putFile(formData).then(res => {
        if (res.data.code === 200) {
          this.voucher = res.data.data.link
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 申请退款
    submitRefund: debounce(function () {
      if (!this.refundType) {
        this.$message.warning('submitRefund')
        return
      } else if (!this.refundMoney && this.orderType ===1) {
        this.$message.warning('请填写退款金额！')
        return
      } else if (!this.refundMark) {
        this.$message.warning('请填写退款理由')
        return
      }
      let postData = {
        content: this.refundMark.trim(),
        refundType:this.refundType,
        refundAmount:this.refundMoney,
        bizRefrenceId: this.checkItem.id
      }
      applyForRefund(postData).then(res => {
        if (res.data.code === 200) {
          this.showRefund = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 申请补单
    submitFix: debounce(function () {
      if (!this.voucher) {
        this.$message.warning('请上传凭证！')
        return
      }
      let postData = {
        content: this.fixRemark.trim(),
        attachment: this.voucher,
        bizRefrenceId: this.checkItem.id
      }
      applyForSupplement(postData).then(res => {
        if (res.data.code === 200) {
          this.showFix = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 导出
    exportList () {
      let postData = {
        startDate: this.searchTime ? this.searchTime[0] : '',
        endDate: this.searchTime ? this.searchTime[1] : '',
        orderId: this.orderNo === undefined ? '': this.orderNo,
        enterpriseName: this.enterpriseName,
        deptId: this.deptId,
        payOrderNo: this.payOrderNo,
        mobile: this.mobile,
        orderCreateDate: this.orderCreateDate,
        payTime: this.payTime,
        refundTime: this.refundTime,
        appId: this.appId,
        payType: this.payType,
        payStatus: this.orderStatus,
        refundReviewStatus: this.refundStatus,
        supplementReviewStatus: this.fixStatus,
        productType: this.productType,
        isRenew: this.categoryType,
        invoiceReviewStatus: this.invoiceStatus
      }
      exportOrder(postData)
    }
  }
}
</script>
<style lang="scss">
.form-upload-img {
  .el-form-item__content img {
    width: 200px;
    margin-right: 10px;
    display: inline-block;
  }
}
.demo-table-expand .el-form-item{
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
</style>
